import { AiFillCreditCard } from "react-icons/ai";
// import { handleDownload } from "./Utils";

export const config = (onView, withFilter) => [
  {
    name: "Numéro facture",
    selector: (row) => row.invoice_number,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Montant hors taxes",
    selector: (row) => row.amount_excluding_tax,
    sortable: true,
    filterable: withFilter,
    cell: (row) =>
      row.amount_excluding_tax === 0 ? "" : row.amount_excluding_tax,
  },
  {
    name: "TVA montant",
    selector: (row) => row.amount_vat,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Montant (TTC)",
    selector: (row) => row.amount_incl_vat,
    sortable: true,
    filterable: withFilter,
    cell: (row) => (row.amount_incl_vat === 0 ? "" : row.amount_incl_vat),
  },
  {
    name: "Montant réglé",
    selector: (row) => row.amount_to_pay,
    sortable: true,
    filterable: withFilter,
    cell: (row) => (row.amount_to_pay === 0 ? "" : row.amount_to_pay),
  },
  {
    name: "Montant non réglé",
    selector: (row) => row.amount_unpaid,
    sortable: true,
    filterable: withFilter,
    cell: (row) => (row.amount_unpaid === 0 ? "" : row.amount_unpaid),
  },
  {
    name: "Statut",
    selector: (row) => row.status,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Date d'échéance",
    selector: (row) => row.due_date,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Payer",
    selector: (row) => row.invoice_number && row.invoice_number,
    cell: (row) => (
      <>
        <AiFillCreditCard style={{ color: "#ccc" }} />
      </>
    ),
  },
];
